<script>
  import { onMount } from 'svelte';

  import Hero from '../hero.svelte';

  const minCount = 4;
  const maxCount = 10;
  const minHour = 2;
  const maxHour = 8;
  const perBodyPrice = 5000;
  const perHourPrice = 10000;
  const minPrice = 20000;

  // mode 0 = 사람 * 이용시간
  // mode 1 = 종일권
  // mode 2 = 야간권
  let isDay = false;
  let isNight = false;
  let dayBtn, nightBtn, equiBtn, resetBtn;

  const setMode0 = () => {
    mode = 0;
    isDay = false;
    isNight = false;
    dayBtn.classList.remove('active');
    nightBtn.classList.remove('active');
  };
  const setMode1 = () => {
    if (isDay === true) {
      setMode0();
      return;
    }
    mode = 1;
    isNight = false;
    isDay = true;
    dayBtn.classList.add('active');
    nightBtn.classList.remove('active');
  };
  const setMode2 = () => {
    if (isNight === true) {
      setMode0();
      return;
    }
    mode = 2;
    isDay = false;
    isNight = true;
    dayBtn.classList.remove('active');
    nightBtn.classList.add('active');
  };
  const handleEqui = () => {
    equi = !equi;
    if (equi) {
      equiBtn.classList.add('active');
    } else {
      equiBtn.classList.remove('active');
    }
  };
  let lastMode = 0;
  //$: mode = setMode(isDay, isNight);
  let mode = 0;
  let count = 4;
  let hour = 2;
  let equi = false;

  $: priceMode = mode === 0 ? '일반권' : mode === 1 ? '종일권' : '야간권';

  const calc = (mode, count, hr, equi) => {
    let retval = equi ? 10000 : 0;
    let additionalCountPrice = 0;
    let additionalHourPrice = 0;

    if (mode === 0) {
      retval += minPrice;
      //인원
      const countGap = count - minCount;
      additionalCountPrice = countGap <= 0 ? 0 : countGap * perBodyPrice;
      retval += additionalCountPrice;

      const hourGap = hr - minHour;
      additionalHourPrice = hourGap <= 0 ? 0 : hourGap * perHourPrice;
      retval += additionalHourPrice;
    } else if (mode === 1) {
      retval += 100000;
    } else if (mode === 2) {
      retval += 50000;
    } else {
      return ['계산오류 :('];
    }

    return [retval, additionalCountPrice, additionalHourPrice, equi];
  };

  $: finalPrice = calc(mode, count, hour, equi);
  $: dispTextDeco =
    mode === 1 || mode === 2 ? 'text-decoration:line-through;' : '';

  const makeCountString = (count) => {
    if (count === 4) {
      return '1~4';
    }
    if (count === 10) {
      return '10+';
    }
    return count;
  };
  $: countString = makeCountString(count);

  const handleReset = () => {
    lastMode = 0;
    mode = 0;
    count = 4;
    hour = 2;
    equi = false;
    setMode0();
    equiBtn.classList.remove('active');
    resetBtn.classList.add('active');
    setTimeout(() => {
      resetBtn.classList.remove('active');
    }, 200);
  };
</script>

<article class="calc-container">
  <div class="price-container-wrapper">
    <div class="price-indicator">
      <strong>{priceMode}</strong>&nbsp;예상가격
    </div>
    <div class="price-wrapper">
      <span class="is-empty hide-on-phone" />
      <span class="price-sign">&#8361</span>
      <span class="price-value">
        {finalPrice.at(0).toLocaleString('en', { useGrouping: true })}
      </span>
      <span class="is-empty hide-on-phone" />
    </div>
    <!-- <span class="is-empty" /> -->
  </div>
  <div class="select-container-wrapper">
    <div class="count-slider-container" on:mousedown={setMode0}>
      <div class="disp-wrapper" style={dispTextDeco}>
        <span class="disp-value"
          >{countString}&nbsp;<span class="detail">명</span></span
        >
        <!-- <span class="disp-desc">명</span> -->
      </div>

      <div class="slider-wrapper">
        <input
          type="range"
          min={minCount}
          max={maxCount}
          step="1"
          bind:value={count}
          class="slider count"
          on:input={setMode0}
        />
      </div>
    </div>
    <div class="hour-slider-container">
      <div class="disp-wrapper" style={dispTextDeco} on:mousedown={setMode0}>
        <span class="disp-value"
          >{hour}&nbsp;<span class="detail">시간</span></span
        >
        <!-- <span class="disp-desc">시간</span> -->
      </div>
      <div class="slider-wrapper" on:mousedown={setMode0}>
        <input
          type="range"
          min={minHour}
          max={maxHour}
          step="1"
          bind:value={hour}
          class="slider hour"
          on:input={setMode0}
        />
      </div>
    </div>
    <div class="equi-container ">
      <div class="check-equi" on:click={handleEqui}>
        <div class="button-wrapper check-box-desc" bind:this={equiBtn}>
          장비대여
        </div>
      </div>

      <div class="is-empty" />
    </div>
    <div class="mode-container ">
      <div
        class="check-day "
        on:mousedown={() => {
          setMode1();
        }}
      >
        <div class="button-wrapper check-box-desc" bind:this={dayBtn}>
          종일권
        </div>
      </div>
      <div class="check-night" on:mousedown={setMode2}>
        <div class="button-wrapper check-box-desc" bind:this={nightBtn}>
          야간권
        </div>
      </div>
    </div>
  </div>
</article>
<button
  on:mousedown={handleReset}
  class="reset-button button-wrapper check-box-desc"
  bind:this={resetBtn}>다시 계산하기</button
>
<div class="css-keeper button-wrapper active check-box-desc" />

<style>
  .calc-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    border: 1px solid #f4f4f4;
    box-shadow: 1px 1px 2px #888;
    border-radius: 10px;
    padding: 20px;
    overflow: hidden;
  }
  .select-container-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 2fr 1fr;
    width: 100%;
    height: 300px;
  }
  .count-slider-container,
  .hour-slider-container,
  .equi-container,
  .mode-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .equi-container,
  .mode-container {
    gap: 10px;
  }
  .check-box {
    display: inline;
    /* transform: scale(3); */
  }
  .check-equi,
  .is-empty,
  .check-day,
  .check-night {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .check-equi,
  .equi-container,
  .check-day,
  .check-night {
    width: 100%;
    height: 100%;
  }

  .button-wrapper {
    /* display: block; */
    /* height: 100%; */
  }

  .disp-wrapper {
    flex: 1;
    width: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
  }
  .disp-desc,
  .disp-value {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .disp-value .detail {
    font-weight: 200;
  }
  .disp-desc {
    font-weight: 200;
    font-size: 40px;
  }
  .disp-value {
    font-weight: 500;
    font-size: 64px;
  }
  .slider-wrapper {
    flex: 1;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .slider.count,
  .slider.hour {
    width: 70%;
  }
  .check-box {
    margin: 0;
    margin-right: 30px;
    width: 24px;
    height: 24px;
  }
  .check-box-desc {
    font-weight: 200;
    font-size: 35px;
    /* width: 100%; */
    margin: 0 auto;
    height: auto;
    border-radius: 10px;
    border: 1px solid #ddd;
    box-shadow: 2px 2px 1px #333;
    padding: 10px;
    width: 80%;
    text-align: center;
    transition: 0.1s;

    background-color: #f5f5f5;
    /* background-color: #333; */
    color: #333;
    /* color: #fdb501; */
    font-weight: 400;

    user-drag: none;
    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
  @media screen and (min-width: 768px) {
    .check-box-desc:hover {
      transform: translate(-2px, -2px);
      box-shadow: 4px 4px 1px #777;
      cursor: pointer;
    }
  }

  .check-box-desc.active {
    transform: translate(4px, 4px);
    box-shadow: 0px 0px 0px #333;
    /*  */
    /* background-color: #333; */
    font-weight: 500;
    -webkit-text-stroke-width: 1px;
    color: #026cc3;
    /* -webkit-text-stroke-color: #fdb501; */
  }
  .reset-button {
    width: 100%;
  }

  .price-container-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 300px;
    align-items: center;
    justify-content: center;
  }
  .price-indicator {
    flex: 1;
    font-weight: 300;
    font-size: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .price-wrapper {
    flex: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .price-sign {
    font-weight: 400;
    font-size: 56px;
    flex: 1;
    text-align: center;
  }

  .price-value {
    font-weight: 500;
    font-size: 80px;
    flex: 4;
  }

  /* .reset-button {
    font-size: 20px;
    width: 100%;
    margin: 0;
    flex: 1;
    border-radius: 10px;
    box-shadow: 1px 1px 2px rgba(3, 3, 3, 0.2);
    background-color: #f5f5f5;
  } */

  @media screen and (max-width: 1300px) {
    .disp-value {
      font-size: 50px;
    }
    .check-box-desc {
      font-size: 3.5vw;
    }
  }

  @media screen and (max-width: 768px) {
    .calc-container {
      grid-template-columns: 1fr;
      grid-auto-flow: row;
      /* row-gap: 7vh; */
      padding: 7px;
      margin-bottom: 10px;
    }
    .price-container-wrapper,
    .select-container-wrapper {
      width: 100%;
    }
    .select-container-wrapper {
      grid-template-columns: 1fr 1fr;
      grid-template-columns: 1fr 1fr;
    }
    .price-container-wrapper {
      height: 30vh;
      border-bottom: 1px solid rgba(3, 3, 3, 0.2);
      margin-top: 3vh;
      padding-top: 3vh;
    }
    .hide-on-phone {
      display: none;
    }
    .disp-desc {
      font-size: 8vw;
    }
    .disp-desc:after {
      content: ':';
    }
    .disp-wrapper {
      flex: 2;
    }
    .disp-value {
      font-size: 13vw;
    }
    .price-container-wrapper {
      height: 25vh;
    }
    .check-box {
      margin-right: 10px;
    }
    .check-box-desc {
      font-size: 6vw;
    }
    .reset-button {
      border-radius: 10px;
      font-size: 6vw;
    }

    .count-slider-container,
    .hour-slider-container {
    }

    .price-value {
      font-weight: 500;
      font-size: 19vw;
      flex: 4;
    }
  }
  .css-keeper {
    display: none;
  }
</style>
